<template>
  <div class="m-5 md:m-15 2xl:m-20">
    <!-- Popup message alert if save is not possible (Evaluation in progress on this template) -->
    <EvalInProgress
      :evaluation-in-progress="evaluationInProgress"
      @massAssignation="displayAssignTemplate()"
      @showPreview="showPreview = true"
    />
    <!-- END Popup message alert -->

    <mass-template-assignation
      :opened="massAssignation"
      @close="massAssignation = false"
      :template="massAssignationTemplate"
    />

    <!-- BEGIN Popup confirm delete template -->
    <popup
      :opened="confirmDeleteTemplate > -1"
      @close="confirmDeleteTemplate = -1"
    >
      <!-- Screen to ask a confirmation to close current evaluation -->
      <div v-if="confirmDeleteTemplate == 0">
        <div class="my-5 xl:my-15">
          <h3 class="mb-5 md:mb-10 2xl:mb-15">
            Supprimer le modèle de page "{{ templateNameToDelete }}"
          </h3>

          <div class="mb-10">
            <p class="text-indigo-600 text-lg text-center">
              Êtes-vous sûr de vouloir supprimer le modèle de page "{{
                templateNameToDelete
              }}" ?
            </p>
            <p class="text-indigo-600 text-lg text-center">
              Cette suppression sera définitive et irrévocable.
            </p>
          </div>

          <div class="flex justify-center bg-pink">
            <action-button
              class="mr-4"
              border-color="border-pink-600"
              text-color="text-pink-600"
              bg-color="bg-pink-300"
              libelle="ANNULER"
              @clickAction="confirmDeleteTemplate = -1"
            />
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-pink-600"
              libelle="SUPPRIMER"
              type-shadow="shadow-pink"
              @clickAction="confirm_delete_template"
            />
          </div>
        </div>
      </div>
      <!-- END Screen to ask a confirmation to close current evaluation -->

      <!-- Screen to confirm the close -->
      <div v-if="confirmDeleteTemplate == 1">
        <h3 class="w-full text-indigo-600 mt-12 mb-10">
          Le modèle de page "{{ templateNameToDelete }}"<br>a bien été
          supprimé !
        </h3>
        <illustration
          name="basket"
          class="w-full m-5"
        />
      </div>
      <!-- END Screen to confirm the close -->

      <!-- If template to delete is assigned on at least 1 beneficiary -->
      <div v-if="confirmDeleteTemplate == 2">
        <div class="my-5 xl:my-15">
          <h3 class="mb-5 md:mb-10 2xl:mb-15">
            Supprimer le modèle de page "{{ templateNameToDelete }}"
          </h3>

          <div class="mb-5">
            <p class="text-indigo-600 text-lg text-center">
              Êtes-vous sûr de vouloir supprimer le modèle de page "{{
                templateNameToDelete
              }}" ?
            </p>
            <p class="text-indigo-600 text-lg text-center">
              Cette suppression sera définitive et irrévocable.
            </p>
          </div>

          <div class="mb-10">
            <p class="text-pink-600 text-lg text-center">
              Attention, ce modèle de page est utilisé par
              {{ listAssignedUsersTemplate.length }} bénéficiaire<span
                v-if="listAssignedUsersTemplate.length > 1"
              >s</span>
              :
            </p>
            <p class="text-pink-600 text-lg text-center">
              <span
                v-for="(beneficiary, index) in listAssignedUsersTemplate"
                :key="beneficiary.id"
              >
                <span v-if="index > 0">-&nbsp;</span>{{ beneficiary.firstname }}
                <span class="uppercase">{{ beneficiary.lastname }}</span>
              </span>
            </p>
            <p class="text-pink-600 text-lg text-center">
              En cas de suppression, le modèle de page "{{
                templatePageToAssignAfterDelete.name
              }}" leur sera attribué.
            </p>
          </div>

          <div class="flex justify-center bg-pink">
            <action-button
              class="mr-4"
              border-color="border-pink-600"
              text-color="text-pink-600"
              bg-color="bg-pink-300"
              libelle="ANNULER"
              @clickAction="confirmDeleteTemplate = -1"
            />
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-pink-600"
              libelle="SUPPRIMER"
              type-shadow="shadow-pink"
              @clickAction="
                confirm_delete_template(templatePageToAssignAfterDelete)
              "
            />
          </div>
        </div>
      </div>
      <!-- END If template to delete is assigned on at least 1 beneficiary -->
    </popup>
    <!-- END Popup confirm delete template -->

    <!-- BEGIN Popup confirm deactivate template -->
    <deactivate-template-popup
      :confirm-deactivate-template="confirmDeactivateTemplate"
      :template-name-to-deactivate="templateNameToDeactivate"
      :list-assigned-users-template="listAssignedUsersTemplate"
      :template-page-to-assign-after-delete="templatePageToAssignAfterDelete"
      @confirm_deactivate_template="
        (templatePageToAssignAfterDelete) => {
          confirm_deactivate_template(templatePageToAssignAfterDelete);
        }
      "
      @close="confirmDeactivateTemplate = -1"
    />
    <!-- END Popup confirm deactivate template -->

    <!-- BEGIN Popup confirm activate template -->
    <activate-template-popup
      :confirm-activate-template="confirmActivateTemplate"
      :template-name-to-deactivate="templateNameToDeactivate"
      @confirm_activate_template="confirm_activate_template()"
      @close="confirmActivateTemplate = -1"
    />
    <!-- END Popup confirm activate template -->

    <!-- Popup modal preview -->
    <popup
      :opened="showPreview"
      @close="showPreview = false"
    >
      <div class="m-5 xl:m-15 2xl:m-20 w-auto h-auto">
        <h3 class="mb-15">
          {{ infosPage.libelle_template }}
        </h3>
        <!-- Content modal -->

        <div
          v-for="(domaine, index) in template"
          :key="index"
        >
          <div class="grid grid-cols-12 mb-15">
            <div
              class="col-span-full text-indigo-600 uppercase text-base font-normal"
            >
              {{ domaine[0].libelle }}
            </div>
            <div class="col-span-full grid grid-cols-12 gap-4">
              <div
                v-for="(field, jndex) in domaine"
                :key="jndex"
                class="col-span-full"
                :class="
                  jndex == 0
                    ? 'display-none'
                    : domaine.length > 2
                      ? 'lg:col-span-4'
                      : 'lg:col-span-6'
                "
              >
                <!-- use $set function to be reactive with form watch property -->
                <input-text
                  v-if="jndex !== 0 && field.type == 'text'"
                  :libelle="field.libelle"
                />
                <input-select
                  v-if="jndex !== 0 && field.type == 'multi'"
                  :name="
                    field.libelle
                      .toLowerCase()
                      .replace(' ', '_')
                      .replace('\'', '') +
                      index +
                      jndex
                  "
                  :libelle="field.libelle"
                  :datas="field.criterions"
                />
                <input-text-area
                  v-if="field.type == 'text-area'"
                  size="5"
                  :name="
                    field.libelle
                      .toLowerCase()
                      .replace(' ', '_')
                      .replace('\'', '')
                  "
                  :libelle="field.libelle"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- END Content modal -->
      </div>
    </popup>
    <!-- END Popup modal preview -->
    <div v-if="isEditable">
      <!-- Title -->
      <div class="flex justify-center">
        <input-title
          class="mb-5 md:mb-15 2xl:mb-20 w-3/4"
          name="title"
          :value="infosPage.libelle_template"
          :disabled="
            !$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER) ||
              this.evaluationInProgress
          "
          :error="true"
          :maxlength="40"
          @input="
            (value) => {
              infosPage.libelle_template = value;
            }
          "
          @valid="
            (title) => {
              SET_NAME_TEMPLATE_IN_LIST([infosPage.id_template, title]);
            }
          "
        />
      </div>
      <!-- END Title -->

      <!-- BEGIN Bloc action buttons -->
      <list-buttons
        :evaluation-in-progress="evaluationInProgress"
        :is-active="infosPage.is_active"
        @preview="
          () => {
            showPreview = true;
          }
        "
        @deactivateTemplate="displayConfirmDeactivateTemplate()"
        @activateTemplate="displayConfirmActivateTemplate()"
        @confirmDelete="
          () => {
            displayConfirmDeleteTemplate();
          }
        "
        @assignTemplate="displayAssignTemplate()
        "
        can-delete
      />
      <!-- END Bloc action buttons -->

      <!-- BEGIN Template contents -->
      <div class="flex flex-col">
        <!-- BEGIN list domaine -->
        <div
          class="flex flex-row self-center relative justify-end items-center cursor-pointer my-8 w-max-content w-max"
          @click="displayFieldList"
          @click.stop
        >
          <div class="flex flex-row ml-auto items-end">
            <h3
              v-if="(template || []).length > 0"
              class="text-xl text-indigo-600"
            >
              {{
                'Domaine ' +
                  (currentField + 1) +
                  '. ' +
                  template[currentField][0].libelle
              }}
            </h3>
            <h3
              v-else-if="$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
              @click.stop="addDomaine()"
              class="text-xl text-indigo-600"
            >
              Ajouter un domaine
            </h3>
          </div>
          <div
            class="text-pink-600 max-h-8 mr-auto rounded-full relative inline-flex items-center p-2 order-2"
          >
            <icon
              v-if="template.length > 0"
              class="h-4 w-4"
              name="chevron-down"
            />
          </div>
          <div
            class="fieldlist z-20 w-max-content w-max mt-2 absolute rounded-md bg-white flex transform translate-y-full self-end shadow-md shadow-gray-600 text-sm"
            v-click-outside="displayFieldList"
            v-if="showList"
          >
            <div class="mx-5 my-3">
              <div class="text-left">
                <div
                  class="first:pt-2 py-1"
                  v-for="(field, i) in template"
                  :key="i"
                >
                  <p
                    class="text-gray-600 hover:text-gray-900"
                    @click="currentField = i"
                  >
                    <span>{{
                      'Domaine ' + (i + 1) + ' : ' + field[0].libelle
                    }}</span>
                  </p>
                </div>
                <div
                  v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
                  class="text-gray-600 hover:text-gray-900 pt-3"
                >
                  <span @click.stop="addDomaine()"> Ajouter un domaine </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END list domaine -->

        <!-- BEGIN list criterions -->
        <div v-if="template.length > 0">
          <div
            v-for="(field, index) in template[currentField]"
            :key="index"
            class="grid grid-cols-12 gap-x-4 gap-y-10 place-content-center mb-10"
          >
            <div
              class="col-span-full md:col-span-8 flex flex-col md:flex-row items-start md:items-center justify-between content-center"
            >
              <div class="flex items-center">
                <div
                  class="cursor-pointer mr-4"
                  @click="deleteField(index)"
                  v-if="
                    index > 0 &&
                      $can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)
                  "
                >
                  <span class="minus-button 2xl:h-10 2xl:w-10 2xl:mt-2">
                    <icon name="close" />
                  </span>
                </div>
                <div class="text-gray-900 text-base uppercase">
                  {{ index == 0 ? 'Nom du domaine' : 'Champ ' + (index + 1) }} :
                  {{
                    field.type == 'multi'
                      ? 'Sélection multiple'
                      : field.type == 'text'
                        ? 'Texte'
                        : field.type == 'text-area'
                          ? 'Texte sur plusieurs lignes'
                          : ''
                  }}
                </div>
              </div>
              <checkbox-indigo
                v-if="field.type == 'multi'"
                name="evaluation"
                color-libelle="gray-600"
                libelle="Visible dans la cartographie"
                :value="field.display_cartographie"
                @input="
                  (newValue) => {
                    $set(field, 'display_cartographie', newValue);
                  }
                "
                :disabled="!$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
              />
            </div>

            <!-- BEGIN Field name -->
            <div
              class="lg:col-start-1 col-span-full lg:col-span-3"
              v-if="field.type == 'text' || field.type == 'text-area'"
            >
              <input-text
                v-if="evaluationInProgress"
                :libelle="
                  index == 0 ? '' : 'Libellé du champ : ' + field.libelle
                "
                :value="field.libelle"
                @input="
                  (newValue) => {
                    $set(field, 'libelle', newValue);
                  }
                "
                :disabled="true"
              />
              <input-text
                v-else
                :libelle="
                  index == 0 ? '' : 'Libellé du champ : ' + field.libelle
                "
                :value="field.libelle"
                @input="
                  (newValue) => {
                    $set(field, 'libelle', newValue);
                  }
                "
                :disabled="!$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
              />
            </div>

            <div
              class="lg:col-start-1 col-span-full lg:col-span-3"
              v-if="
                index == 0 && $can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)
              "
            >
              <delete-button
                libelle="Supprimer le domaine"
                @del="deleteDomaine(currentField)"
                :disabled="!$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
              />
            </div>

            <div
              v-if="field.type == 'multi'"
              class="col-span-full grid grid-cols-12 gap-x-4 gap-y-10 place-content-center"
            >
              <div class="lg:col-start-1 col-span-full lg:col-span-3">
                <input-text
                  v-if="evaluationInProgress"
                  :libelle="'Libellé du champ : ' + field.libelle"
                  :value="field.libelle"
                  @input="
                    (newValue) => {
                      $set(field, 'libelle', newValue);
                    }
                  "
                  :disabled="true"
                />
                <input-text
                  v-else
                  :libelle="'Libellé du champ : ' + field.libelle"
                  :value="field.libelle"
                  @input="
                    (newValue) => {
                      $set(field, 'libelle', newValue);
                    }
                  "
                  :disabled="!$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
                />
              </div>
              <!-- END Field name -->

              <!-- BEGIN Criterions list -->
              <p
                class="col-start-1 col-span-full text-base text-gray-900 uppercase"
              >
                Critères d'évaluation {{ index + 1 }}
              </p>
              <!-- <transition-group enter-active-class="ease-in duration-1000" enter-class="bg-indigo-300 border-0 rounded-xl" enter-to-class="bg-none border-0 rounded-xl" tag="div"> -->
              <div
                v-for="(crit, jndex) in field.criterions"
                :key="index.toString() + jndex.toString()"
                class="col-span-full lg:col-span-3 relative"
                :class="{ '': jndex == 0 }"
              >
                <input-text
                  v-if="evaluationInProgress"
                  :name="'critere_' + index + '_' + jndex"
                  :placeholder="'Critère ' + (jndex + 1)"
                  libelle=""
                  :value="crit.value"
                  :disabled="true"
                />
                <input-text
                  v-else
                  :name="'critere_' + index + '_' + jndex"
                  :placeholder="'Critère ' + (jndex + 1)"
                  libelle=""
                  :value="crit.value"
                  @input="
                    (newValue) => {
                      $set(crit, 'value', newValue);
                    }
                  "
                  :disabled="!$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
                />

                <div
                  v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
                  class="absolute flex cursor-pointer bottom-8/12 left-11/12 p-2 2xl:p-2.5 items-center text-pink-600 bg-pink-100 border border-pink-600 border-opacity-25 rounded-full"
                  @click="deleteCriterion(index, jndex)"
                >
                  <icon
                    name="close"
                    class="h-2 w-2 2xl:h-2.5 2xl:w-2.5"
                  />
                </div>
              </div>
              <!-- </transition-group> -->
              <!-- END Criterions list -->

              <!-- BEGIN Button to add a criterion -->
              <div
                v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
                class="col-start-1 col-span-full w-max-content w-max cursor-pointer flex hover:font-medium"
                @click="addCriterion(index)"
              >
                <span class="plus-button 2xl:h-10 2xl:w-10">
                  <icon name="plus" />
                </span>
                <span class="text-base text-gray-600 ml-3 mt-1.5 flex-initial">
                  Ajouter un critère
                </span>
              </div>
            </div>
            <!-- END Button to add a criterion -->
            <hr class="col-span-full border-dashed border-gray-600">
          </div>
        </div>
        <!-- END list criterions -->

        <!-- BEGIN button add field -->
        <AddFieldButton
          v-if="template.length > 0"
          @addMulti="addField('multi')"
          @addText="addField('text')"
          @addTextArea="addField('text-area')"
        />
        <!-- END button add field -->
      </div>
      <!-- END Template contents -->
    </div>
    <div v-else>
      <!-- Title -->
      <div class="mb-5 md:mb-15 2xl:mb-20">
        <h3>
          {{ this.infosPage.libelle_template }}
        </h3>
      </div>
      <!-- END Title -->

      <!-- BEGIN Bloc action buttons -->
      <list-buttons
        :evaluation-in-progress="evaluationInProgress"
        @assignTemplate="displayAssignTemplate()"
        :is-active="infosPage.is_active"
        @preview="
          () => {
            showPreview = true;
          }
        "
        @deactivateTemplate="displayConfirmDeactivateTemplate()"
        @activateTemplate="displayConfirmActivateTemplate()"
        :can-delete="false"
      />
      <!-- END Bloc action buttons -->

      <!-- Custom content -->
      <div class="mx-15">
        <!-- Contenu de la partie personnalisable -->
        <h3 class="text-lg text-gray-600">
          Le modèle de page {{ this.infosPage.libelle_template }} n'est pas
          modifiable.<br>
          Vous pouvez simplement
          <span v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER)">activer ou désactiver</span><span v-else>visualiser</span> le modèle de page.
        </h3>
        <div class="my-15 flex justify-center">
          <illustration name="notAllowed" />
        </div>
      </div>
      <!-- END Custom content -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import InputText from '../../components/Inputs/InputText';
import InputTextArea from '../../components/Inputs/InputTextArea';
import InputSelect from '../../components/Inputs/InputSelect';
import CheckboxIndigo from '../../components/Inputs/CheckboxIndigo';
import InputTitle from '../../components/Inputs/InputTitle';

import ClickOutside from 'vue-click-outside';
import ActionButton from '../../components/ActionButton';
import Icon from '../../components/Icon';
import Illustration from '../../components/Illustration';
import Popup from '../../components/Popup';
import ListButtons from './../../components/Templates/listButtons.vue';
import DeleteButton from './../../components/Inputs/DeleteButton';

import store from '../../store';

import DeactivateTemplatePopup from './../../components/Templates/DeactivateTemplatePopup';
import ActivateTemplatePopup from './../../components/Templates/ActivateTemplatePopup';

import Constants from './../../constants';
import EvalInProgress from './EvalInProgress.vue';
import AddFieldButton from './AddFieldButton.vue';
import MassTemplateAssignation from './popups/MassTemplateAssignation.vue';

export default {
  components: {
    AddFieldButton,
    EvalInProgress,
    MassTemplateAssignation,
    InputText,
    InputSelect,
    Icon,
    ActionButton,
    Popup,
    Illustration,
    InputTextArea,
    CheckboxIndigo,
    ListButtons,
    DeleteButton,
    DeactivateTemplatePopup,
    ActivateTemplatePopup,
    InputTitle,
  },

  name: 'ReferentielMulti3',

  data() {
    return {
      confirmDeleteTemplate: -1,
      confirmDeactivateTemplate: -1,
      confirmActivateTemplate: -1,
      editName: false,
      dropDownMenu: false,
      template: [],
      showPreview: false,
      nom_langue_preview: 'Anglais', //langue in first field on preview screen
      currentField: 0,
      showList: false,
      templateNameToDelete: '',
      templateNameToDeactivate: '',
      massAssignation: false,
      massAssignationTemplate: {},
      constants: Constants,
    };
  },

  mounted() {
    this.initPage();
  },

  async beforeRouteUpdate(to, from, next) {
    store.commit('app/SET_LOADING', true);
    let url = to.path.split('/modeles-de-page/')[1].split('/');

    await store.dispatch('template/change_page', url).then((response) => {
      store.commit('app/SET_LOADING', true);
      this.initPage();
      next();
    });
  },

  methods: {
    ...mapActions({
      save_datas: 'template/save_datas',
      delete_template: 'template/delete_template',
      switchState: 'template/switchState',
    }),
    ...mapMutations({
      SET_TEMPLATEVERSIONS: 'template/SET_TEMPLATEVERSIONS',
      SET_TEMPLATECONTENT: 'template/SET_TEMPLATECONTENT',
      SET_LIBELLE_TEMPLATE: 'template/SET_LIBELLE_TEMPLATE',
      SET_NAME_TEMPLATE_IN_LIST: 'template/SET_NAME_TEMPLATE_IN_LIST',
      SET_ISACTIVE: 'template/SET_ISACTIVE',
      SET_MESSAGEHEADER: 'template/SET_MESSAGEHEADER',
      SET_EVALUATION_FIELD: 'template/SET_EVALUATION_FIELD',
    }),

    displayAssignTemplate() {
      this.massAssignationTemplate = {
        id: this.infosPage.id_template,
        name: this.infosPage.libelle_template,
        page_id: this.infosPage.id_page
      };
      this.massAssignation = true;
    },

    loadEmptyForm() {
      this.template = [];
    },

    initTemplate() {
      if (this.templateContent.length > 0) {
        //load values in form and keep templateContent with initial values to compare when leave page without saving
        this.template = [...this.templateContent];
      }
    },

    async initPage() {
      await this.loadEmptyForm();
      await this.initTemplate();

      this.currentField = 0;

      store.commit('app/SET_LOADING', false);
      this.infosPage.isTemplateChanged = false;
    },

    displayFieldList() {
      this.showList = !this.showList;
    },

    confirm_delete_template(templateToReplace = null) {
      this.delete_template(templateToReplace), (this.confirmDeleteTemplate = 1);
    },

    displayDropdownMenu() {
      this.dropDownMenu = !this.dropDownMenu;
    },

    forceHide(e) {
      if (e.target.classList.contains('dropdown-menu')) {
        this.displayDropdownMenu();
      } else {
        if (this.dropDownMenu) {
          this.dropDownMenu = false;
        }
      }
    },

    addDomaine() {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.template.push([{ type: 'text', libelle: 'Nom du domaine' }]);
        this.currentField = this.template.length - 1;
      }
    },

    deleteDomaine(domaine) {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        if (domaine == this.template.length - 1) {
          this.currentField = domaine - 1;
          this.template.splice(domaine, 1);
        } else {
          this.template.splice(domaine, 1);
        }
      }
    },

    addField(type) {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.template[this.currentField].push({
          type: type,
          libelle: 'Nom du champ',
          criterions: [],
          evaluation: false,
        });
        this.dropDownMenu = false;
      }
    },

    deleteField(index) {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.template[this.currentField].splice(index, 1);
      }
    },

    addCriterion(index) {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        if (this.template[this.currentField][index].criterions.length < 10) {
          this.template[this.currentField][index].criterions.push({
            value: '',
          });
        } else {
          this.SET_MESSAGEHEADER({
            type: 'warning',
            msg: 'Vous avez atteint la limite de 10 critères maximum',
          });
          setTimeout(() => {
            this.SET_MESSAGEHEADER(null);
          }, 3000);
        }
      }
    },
    deleteCriterion(index, jndex) {
      if (
        !this.evaluationInProgress &&
        this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      ) {
        this.template[this.currentField][index].criterions.splice(jndex, 1);
      }
    },

    displayConfirmDeleteTemplate() {
      if (
        this.templatePageToAssignAfterDelete == null ||
        this.templatePageToAssignAfterDelete == undefined
      ) {
        this.SET_MESSAGEHEADER({
          type: 'error',
          msg: 'Vous ne pouvez pas supprimer le dernier modèle de ce type',
        });
        setTimeout(() => {
          this.SET_MESSAGEHEADER(null);
        }, 3000);
        return;
      }
      if (this.listAssignedUsersTemplate.length == 0) {
        this.confirmDeleteTemplate = 0;
      }
      if (this.listAssignedUsersTemplate.length > 0) {
        this.confirmDeleteTemplate = 2;
      }

      this.templateNameToDelete = this.infosPage.libelle_template;
    },

    displayConfirmDeactivateTemplate() {
      if (
        this.templatePageToAssignAfterDelete == null ||
        this.templatePageToAssignAfterDelete == undefined
      ) {
        this.SET_MESSAGEHEADER({
          type: 'error',
          msg: 'Vous ne pouvez pas désactiver le dernier modèle de ce type',
        });
        setTimeout(() => {
          this.SET_MESSAGEHEADER(null);
        }, 3000);
        return;
      }

      if (this.listAssignedUsersTemplate.length == 0) {
        this.confirmDeactivateTemplate = 0;
      }
      if (this.listAssignedUsersTemplate.length > 0) {
        this.confirmDeactivateTemplate = 2;
      }

      this.templateNameToDeactivate = this.infosPage.libelle_template;
    },

    displayConfirmActivateTemplate() {
      this.confirmActivateTemplate = 0;
      this.templateNameToDeactivate = this.infosPage.libelle_template;
    },

    confirm_deactivate_template(templateToReplace = null) {
      this.switchState({
        state: !this.infosPage.is_active,
        newTemplateToAssign: templateToReplace,
      });
      this.confirmDeactivateTemplate = 1;
    },

    confirm_activate_template() {
      this.switchState({
        state: !this.infosPage.is_active,
        newTemplateToAssign: null,
      });
      this.confirmActivateTemplate = 1;
    },
  },

  computed: {
    ...mapGetters({
      infosPage: 'template/infosPage',
      listPageTemplates: 'template/listPageTemplates',
      templateVersions: 'template/templateVersions',
      templateContent: 'template/templateContent',
      evaluationInProgress: 'template/evaluationInProgress',
      listAssignedUsersTemplate: 'template/listAssignedUsersTemplate',
    }),

    templatePageToAssignAfterDelete() {
      let nextPageTemplate = this.listPageTemplates.filter(
        (t) =>
          t.page_name == this.infosPage.name_page &&
          t.id != this.infosPage.id_template &&
          t.is_active == 1
      );
      return nextPageTemplate.length > 0 ? nextPageTemplate[0] : null;
    },

    isEditable() {
      return (
        (typeof this.infosPage.editable === 'boolean' &&
          this.infosPage.editable === true) ||
        (typeof this.infosPage.editable === 'number' &&
          this.infosPage.editable === 1) ||
        (typeof this.infosPage.editable === 'string' &&
          this.infosPage.editable === '1')
      );
    },
  },

  watch: {
    template: {
      handler() {
        this.infosPage.isTemplateChanged = true;
      },
      deep: true,
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>